import React, { useEffect, useRef } from "react";
import s from './MyTextarea.module.css';

export function MyTextarea({data, setData, maxScrollHeight = null}) {
	
	const textareaRef = useRef(null);
	
	const updateData = (e) => {
		setData(e.target.value);
		handleTextareaChange();
	}
	
	const handleTextareaChange = () => {
		const textarea = textareaRef.current;
		//textarea.style.height = 'auto';
		let scrollHeight = textarea.scrollHeight;
		if (maxScrollHeight != null && scrollHeight > maxScrollHeight) {
			scrollHeight = maxScrollHeight;
		}
		textarea.style.height = `${scrollHeight}px`;
	};
	
	const handleWindowResize = () => {
		handleTextareaChange();
	};
	
	useEffect(() => {
		window.addEventListener('resize', handleWindowResize);
		handleTextareaChange();
		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	}, []);
	
	return (<textarea className={s.textArea}
					ref={textareaRef}
					onChange={updateData}
					rows={1}
					value={data}
					style={{ resize: 'none', overflowY: (maxScrollHeight == null) ? 'hidden' :'scroll' }}
				/>);
}
